module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAALdJREFUOE/FlMEJwkAQRd8X0bPagSVYgzXYgyVoAaae3AU7sAVvXkQ9q5AxCSxEIejoiHtZWIY3+/mfL4KPgnnUQDPrAFOg/+GCC7CWVCTgCFgBO+DmhHaBMbCUdHwG1o8eoJmlz7QDzWzegO4l5W1L3gXOGoCDpM1XwAjJw9LhDDgDhQcIVAkZAAtJp2RKdU9Kp3tOWBq/AltJ9jNguOSHLHlk/yc24cGOlBxWDrH15ZH4aja8se9KspgV3TfF3AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/device.png
// module id = IBUc
// module chunks = 1